(function (window, document) {
  'use strict';

  if (window.CPCartBridge) return;

  function cartSurface() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function cartEndpoint() {
    var route = (window.routes && window.routes.cart_add_url) || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root + 'cart/add' : '/cart/add');
    route = String(route || '/cart/add');
    if (!/\.js(?:[?#]|$)/.test(route)) {
      var split = route.match(/^([^?#]+)(.*)$/);
      route = (split ? split[1] : route) + '.js' + (split ? split[2] : '');
    }
    return route;
  }

  function normalise(items) {
    return (Array.isArray(items) ? items : [items]).map(function (item) {
      if (!item) throw new Error('A product selection is missing. Please check the product page.');
      var id = String(item.id || item.variant || '').trim();
      var quantity = item.quantity == null ? 1 : Number(item.quantity);
      if (!/^[1-9]\d*$/.test(id)) throw new Error('A valid product option is required. Please open the product page.');
      if (!Number.isSafeInteger(quantity) || quantity < 1) throw new Error('Enter a positive whole-number quantity. Nothing has been added.');
      var plan = String(item.selling_plan || item.sellingPlan || '').trim();
      if (plan && !/^[1-9]\d*$/.test(plan)) throw new Error('The purchase plan could not be confirmed. Please reselect it on the product page.');
      return { id: id, quantity: quantity, selling_plan: plan, properties: item.properties || {}, product: item.product || null, meta: item.meta || null };
    });
  }

  function requestConfig(formData) {
    var config;
    if (typeof fetchConfig === 'function') {
      config = fetchConfig('javascript');
      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
    } else {
      config = {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      };
    }
    config.body = formData;
    return config;
  }

  async function addOne(item, surface, activeElement) {
    var formData = new FormData();
    formData.append('id', item.id);
    formData.append('quantity', String(item.quantity));
    if (item.selling_plan) formData.append('selling_plan', item.selling_plan);
    Object.keys(item.properties).forEach(function (key) {
      var value = item.properties[key];
      if (typeof value === 'string' || typeof value === 'number') formData.append('properties[' + key + ']', String(value));
    });

    if (surface && typeof surface.getSectionsToRender === 'function') {
      var sections = surface.getSectionsToRender().map(function (section) { return section.id; }).filter(Boolean);
      if (sections.length) formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);
      if (activeElement && typeof surface.setActiveElement === 'function') surface.setActiveElement(activeElement);
    }

    var response = await fetch(cartEndpoint(), requestConfig(formData));
    var data;
    try {
      data = await response.json();
    } catch (_) {
      data = {};
    }
    if (!response.ok || data.status) {
      var message = data.description || data.message || (data.errors && String(data.errors)) || ('Cart request failed (' + response.status + ')');
      var error = new Error(message);
      error.response = data;
      throw error;
    }
    if (!data.id || !data.key) {
      throw new Error('The basket response could not be confirmed. Open your basket before trying again.');
    }
    return data;
  }

  async function refreshFallbackCount() {
    try {
      var response = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + '?sections=cart-icon-bubble', {
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) return null;
      var sections = await response.json();
      var bubble = document.querySelector('#cart-icon-bubble');
      var rendered = typeof sections['cart-icon-bubble'] === 'string' && new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (bubble && rendered) bubble.innerHTML = rendered.innerHTML;
      return sections;
    } catch (_) {
      return null;
    }
  }

  function publishUpdate(data, source, variantId) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: source || 'cp-cart-bridge',
          productVariantId: variantId || null,
          cartData: data
        });
      }
    } catch (_) {}
  }

  async function addItems(items, options) {
    options = options || {};
    var valid = normalise(items);
    if (!valid.length) throw new Error('No purchasable variant was supplied.');

    var surface = cartSurface();
    var added = [];
    var failed = [];
    var latest = null;

    for (var i = 0; i < valid.length; i += 1) {
      var item = valid[i];
      try {
        latest = await addOne(item, surface, options.activeElement || null);
        added.push(item);
        try { if (window.CPAnalytics) window.CPAnalytics.track('cp_add_to_cart', { variant_id: item.id, quantity: item.quantity, product: item.product && item.product.handle || '', source: options.source || 'cp-cart-bridge', selling_plan_id: item.selling_plan || '' }); } catch (_) {}
        document.dispatchEvent(new CustomEvent('cp:cart:added', { detail: { item: item, response: latest, source: options.source || 'cp-cart-bridge' } }));
      } catch (error) {
        failed.push({ item: item, error: error });
        try { if (window.CPAnalytics) window.CPAnalytics.track('cp_cart_add_failed', { variant_id: item.id, source: options.source || 'cp-cart-bridge' }); } catch (_) {}
      }
    }

    if (!added.length) {
      var firstError = failed[0] && failed[0].error;
      throw firstError || new Error('The basket could not be updated.');
    }

    var sectionIds = surface && typeof surface.getSectionsToRender === 'function' ? surface.getSectionsToRender().map(function (section) { return section.id; }) : [];
    var completeSections = latest && latest.sections && sectionIds.length && sectionIds.every(function (id) { return typeof latest.sections[id] === 'string' && latest.sections[id].trim(); });
    if (surface && completeSections && typeof surface.renderContents === 'function') {
      try {
        surface.renderContents(latest);
        if (surface.classList && surface.classList.contains('is-empty')) surface.classList.remove('is-empty');
      } catch (_) {
        await refreshFallbackCount();
      }
    } else {
      await refreshFallbackCount();
    }

    publishUpdate(latest, options.source || 'cp-cart-bridge', added[added.length - 1].id);

    return { added: added, failed: failed, response: latest };
  }



  function setQuickAddState(button, state, message) {
    if (!button) return;
    var label = button.querySelector('[data-cp-quick-add-label]') || button.querySelector('span') || button;
    if (!button.dataset.cpOriginalLabel) button.dataset.cpOriginalLabel = (label.textContent || '').trim();
    button.classList.toggle('loading', state === 'loading');
    button.disabled = state === 'loading';
    button.setAttribute('aria-disabled', state === 'loading' ? 'true' : 'false');
    if (message) label.textContent = message;
    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', state !== 'loading');
  }

  function restoreQuickAdd(button, delay) {
    window.setTimeout(function () {
      if (!button || !button.isConnected) return;
      var label = button.querySelector('[data-cp-quick-add-label]') || button.querySelector('span') || button;
      if (button.dataset.cpOriginalLabel) label.textContent = button.dataset.cpOriginalLabel;
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      var spinner = button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');
    }, delay || 1800);
  }

  async function handleQuickAddForm(event) {
    var form = event.target && event.target.closest ? event.target.closest('form[data-cp-quick-add-form]') : null;
    if (!form) return;
    event.preventDefault();
    if (form.dataset.cpAdding === 'true') return;
    if (!form.checkValidity()) { form.reportValidity(); return; }
    var button = form.querySelector('[data-cp-cart-add]');
    var idInput = form.querySelector('[name="id"]');
    var id = idInput ? String(idInput.value || '').trim() : String(button && button.dataset.cpCartAdd || '').trim();
    if (!/^\d+$/.test(id) || !button || button.disabled || (idInput && idInput.disabled)) {
      return;
    }
    var quantityInput = form.querySelector('[name="quantity"]');
    var planInput = form.querySelector('[name="selling_plan"]');
    var oldError = form.querySelector('[data-cp-add-error]'); if (oldError) oldError.remove();
    form.dataset.cpAdding = 'true';
    setQuickAddState(button, 'loading', 'Adding…');
    try {
      await addItems([{ id: id, quantity: quantityInput ? Number(quantityInput.value) : 1, selling_plan: planInput ? planInput.value : '' }], { activeElement: button, source: 'cp-card-quick-add' });
      setQuickAddState(button, 'success', 'Added ✓');
      restoreQuickAdd(button, 1800);
    } catch (error) {
      setQuickAddState(button, 'error', 'Try product page');
      var url = button.dataset.cpProductUrl || form.dataset.cpProductUrl;
      if (url) {
        var help = form.querySelector('[data-cp-add-error]');
        if (!help) { help = document.createElement('a'); help.dataset.cpAddError = '1'; form.appendChild(help); }
        help.href = url; help.textContent = 'Check product options';
      }
      restoreQuickAdd(button, 2600);
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartError) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'cp-card-quick-add',
            productVariantId: id,
            errors: String(error && error.message || 'Cart request failed'),
            message: String(error && error.message || 'Cart request failed')
          });
        }
      } catch (_) {}
    } finally { form.dataset.cpAdding = 'false'; }
  }

  document.addEventListener('submit', handleQuickAddForm);

  window.CPCartBridge = {
    addItems: addItems,
    endpoint: cartEndpoint
  };
})(window, document);
